import moment from 'moment';
import MenuRightSerivce from "@/service/MenuRightService";
import InviteNewCandidateService from "@/service/InviteNewCandidateService";
import JobAdsService from "@/service/JobAdsService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { CandidateInvited } from "@/model/CandidateInvited";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import jobApplicationForm from "./S090300-JobApplication/S090300-JobApplication.vue";
import Paginate from "vuejs-paginate";
import Settings from '../../../constants/Settings';
export default {
  name: "JobApplication",
  components: {
    jobApplicationForm, paginate: Paginate,
  },
  mounted() {
    this.assignRights();
    this.clearPagination();
    this.scrollContent();
    this.scrollListData();
    this.getJobadListForCandidatesInvited();
    this.getAllCandidateInvitedList();
  },
  data: () => ({
    jobApplicationLocalization: t,
    menuId: Settings.MenuID.JobApplicationForm,
    Settings: Settings,
    jobApplicationDictEnum: dictEnum,
    selectedJobCandidateInvited: new CandidateInvited(),
    jobAdList: [],
    mobile: '',
    name: '',
    jobCode: '',
    candidateInvitedList: [],
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: this.currentSelectedPage + 1,
    totalRecords: 0,
    menuRights: { allRights: {}, rightsForThisMenu: {} },
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var searchSection = $(".search-result").height();
      var filterSectionHeight = $(".filter-result").height();
      var jobSectionHeight = $(".job-result").height();
      var tableHeaderHeight = $(".job-table table thead").height();
      var pagginationHeight = $(".paggination-job").height();
      var docHeight = documentHeight != undefined ? documentHeight : 662;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var searchHeight = searchSection != undefined ? searchSection : 34;
      var filterHeight = filterSectionHeight != undefined ? filterSectionHeight : 124;
      var jobHeight = jobSectionHeight != undefined ? jobSectionHeight : 34;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 52;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - searchHeight - filterHeight - jobHeight - tHeadHeight - paggHeight;
      // self.take = Number((tableHeight / 47).toFixed());
      self.take = 15;
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    scrollContent: function () {
      $(".body-scroll-area").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    scrollListData: function () {
      $(".list-data").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    async getAllCandidateInvitedByNameMobileKeyWord() {
      var self = this;
      if (self.name == '' && self.mobile == '' && self.jobCode == '') {
        SweetAlertService.warning("Warn", self.jobApplicationLocalization.t(self.jobApplicationDictEnum.WARN_SelectSearch));
        return;
      }
      const obj = {
        take: self.take,
        skip: self.skip,
        name: self.name,
        mobile: self.mobile,
        jobCode: self.jobCode,
      };
      const response = await InviteNewCandidateService.getAllCandidateInvitedByNameMobileKeyWord(obj);
      if (response.data.IsSuccess) {
        self.candidateInvitedList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
        self.$refs.refJobApplicationForm.resetInvitationData();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getJobadListForCandidatesInvited() {
      const obj = {};
      const response = await JobAdsService.getJobadListForCandidates(obj);
      if (response.data.IsSuccess) {
        this.jobAdList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllCandidateInvitedList() {
      var self = this;
      const obj = {
        take: self.take,
        skip: self.skip
      };
      const response = await InviteNewCandidateService.getAllCandidateInvitedList(obj);
      if (response.data.IsSuccess) {
        self.candidateInvitedList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onSelectCandidate(candidate) {
      var self = this;
      var jobDetail = self.jobAdList.find(
        (obj) => obj.JobAdCode == candidate.JobAdCode
      );
      if (jobDetail) {
        candidate.UserName = self.user.Lang == 'EN' ? jobDetail.UserEName : jobDetail.UserCName;
        candidate.UserId = jobDetail.Interviewer;
        candidate.JobName = self.user.Lang == 'EN' ? jobDetail.JobEDesc : jobDetail.JobCDesc;
      }
      self.$refs.refJobApplicationForm.$data.candidateInvited = new CandidateInvited();
      self.selectedJobCandidateInvited = candidate;
      self.$refs.refJobApplicationForm.$data.e1 = 1;
      self.$refs.refJobApplicationForm.$validator.reset();
      self.$refs.refJobApplicationForm.vErrors.clear();
      self.$refs.refJobApplicationForm.$data.selectJobCandidateInvited = candidate;
      self.$refs.refJobApplicationForm.$data.IsCandidateForm = true;
      self.$refs.refJobApplicationForm.getAllCandidateInvitedListByCandid();
      self.$refs.refJobApplicationForm.getCandidateInvitationDetail();
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.currentSelectedPage = pagenumber - 1;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1) - 1;
      if (this.skip != 0) {
        this.skip++;
      }
      if (this.name == '' && this.mobile == '' && this.jobCode == '') {
        this.getAllCandidateInvitedList();
      }
      else {
        this.getAllCandidateInvitedByNameMobileKeyWord();
      }
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    },
    clearPagination: function () {
      var self = this;
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = self.currentSelectedPage + 1;
      self.totalRecords = 0;
      self.init();
    },
    cancelJobApplication: function () {
      var self = this;
      self.$refs.refJobApplicationForm.$data.candidateInvited = new CandidateInvited();
      self.selectedJobCandidateInvited = new CandidateInvited();
      self.$refs.refJobApplicationForm.$data.e1 = 1;
      self.$refs.refJobApplicationForm.$validator.reset();
      self.$refs.refJobApplicationForm.vErrors.clear();
      self.$refs.refJobApplicationForm.$data.selectJobCandidateInvited = new CandidateInvited();
      self.$refs.refJobApplicationForm.$data.candidateJobAdList = [];
      self.mobile = '';
      self.name = '';
      self.jobCode = '';
      self.clearPagination();
      self.getAllCandidateInvitedList();
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobApplicationForm/S090300-JobApplicationForm.js